import { render } from "./DataLoader.vue?vue&type=template&id=21c5bab6"
import script from "./DataLoader.vue?vue&type=script&lang=js"
export * from "./DataLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__